var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 4C19.68 4 17.4534 5.08 16 6.78C14.5467 5.08 12.32 4 10 4C5.88669 4 2.66669 7.22 2.66669 11.3333C2.66669 16.3667 7.20002 20.48 14.0667 26.7133L16 28.4667L17.9334 26.7133C24.8 20.48 29.3334 16.3667 29.3334 11.3333C29.3334 7.22 26.1134 4 22 4ZM16.14 24.74L16 24.8667L15.86 24.74C9.52002 18.9867 5.33335 15.1867 5.33335 11.3333C5.33335 8.67333 7.34002 6.66667 10 6.66667C12.0534 6.66667 14.0534 7.99333 14.7534 9.81333H17.24C17.9467 7.99333 19.9467 6.66667 22 6.66667C24.66 6.66667 26.6667 8.67333 26.6667 11.3333C26.6667 15.1867 22.48 18.9867 16.14 24.74Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWish);
export default __webpack_public_path__ + "static/media/wish.0eb198bf65d0b9e3199eb5c130ca51dd.svg";
export { ForwardRef as ReactComponent };